// extracted by mini-css-extract-plugin
export var link = "Resources-module--link--edd6e";